import React from 'react';

const Highlighter = ({ children }) => {
  return (
    <span className="highlighter-wrapper">
      <span className="highlighter-text">{children}</span>
      <img 
        src="https://customer-assets.emergentagent.com/job_print-showcase-18/artifacts/3nkj2scv_Web-Highlighter.svg" 
        alt="Fluorescent pink highlighter mark - signature element of Clockwork direct mail postcards" 
        className="highlighter-svg"
      />
    </span>
  );
};

export default Highlighter;
